import {v4 as uuidV4} from 'uuid'
import {getValidatedImpression} from '@freckle/educator-entities/ts/common/helpers/split-io-helper'
import StorageHelper from '@freckle/educator-entities/ts/common/helpers/storage-helper'
import {
  saveSplitImpression,
  SaveImpressionData,
} from '@freckle/classroom/ts/common/helpers/api-helper'
import {updatePendoAuthedSplitIOTreatments} from '@freckle/classroom/ts/common/routers/app-router'

const SPLIT_IO_ANONYMOUS_KEY = 'splitIoAnonymousId'

// Global Set to track if we have sent an Impression already
// It's possible that our SplitExperiment can get re-rendered and send a bunch of the same impressions
const _impressionSet = new Set()
function addToImpressionSet(i: SaveImpressionData) {
  _impressionSet.add(JSON.stringify(i))
}
function hasSentImpression(i: SaveImpressionData): boolean {
  return _impressionSet.has(JSON.stringify(i))
}

export function logImpression(impressionData: object | null | undefined) {
  const impression = getValidatedImpression(impressionData)

  if (impression !== null && impression !== undefined) {
    const {keyName, feature: split, treatment, label} = impression
    const teacherId = parseInt(keyName, 10)
    const saveImpressionData = {teacherId, split, treatment, label}
    if (!hasSentImpression(saveImpressionData)) {
      saveSplitImpression({teacherId, split, treatment, label})
      updatePendoAuthedSplitIOTreatments(split, treatment)
      addToImpressionSet(saveImpressionData)
    }
  }
}

function createSplitIOAnonymousId(): string {
  const uuid = uuidV4()
  StorageHelper.setSecureCookie(SPLIT_IO_ANONYMOUS_KEY, uuid.toString())
  return uuid.toString()
}

function getSplitIOAnonymousId(): string | null | undefined {
  return StorageHelper.getCookie(SPLIT_IO_ANONYMOUS_KEY)
}

export function getOrCreateSplitIOAnonymousId(): string {
  const mAnonymousCookieId = getSplitIOAnonymousId()

  return mAnonymousCookieId === null ||
    mAnonymousCookieId === undefined ||
    mAnonymousCookieId.length === 0
    ? createSplitIOAnonymousId()
    : mAnonymousCookieId
}
